<template>
  <!-- 开发日志页面 -->
  <div 
    class="development-log-page" 
    :class="{ 
      'qa-page': developmentLogType === 'qa', 
      'log-page': developmentLogType === 'log', 
      'isMobile': isMobile 
    }"
  >
    <!-- 返回按钮 -->
    <div class="back-btn" @click="goBack"></div>
    
    <!-- 两个按钮 -->
    <div class="development-log-buttons">
      <div 
        class="qa-btn" 
        :class="{ active: developmentLogType === 'qa' }"
        @click="switchDevelopmentLogType('qa')"
      ></div>
      <div 
        class="log-btn" 
        :class="{ active: developmentLogType === 'log' }"
        @click="switchDevelopmentLogType('log')"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted, onUnmounted } from 'vue'

// Props & Emits
const emit = defineEmits(['goBack'])

// 注入的数据
const isMobile = inject('isMobile')

// 响应式数据
const developmentLogType = ref('qa') // 'qa' 或 'log'

// 页面停留时间追踪
const viewPageStartTime = ref(null);

// 计算浏览时长
const formatDuration = (startTime, endTime) => {
  const duration = Math.floor((endTime - startTime) / 1000); // 转换为秒
  // 格式化为 xxHxxMxxS
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  return `${hours > 0 ? hours + 'H' : ''}${minutes > 0 ? minutes + 'M' : ''}${seconds}S`;
};

// 上报页面停留时间
const reportStayTime = () => {
  if (viewPageStartTime.value) {
    window.activityDataLayer.push({
      eventName: 'stay_time',
      eventType: '开发者札记',
      eventValue: formatDuration(viewPageStartTime.value, new Date()),
      aid: window.activity_name,
      gameId: window.game_id
    });
  }
};

// 方法
const goBack = () => {
  reportStayTime();
  emit('goBack');
}
const typeMap = {
  qa: "常见问答",
  log: "开发者日志",
}
const switchDevelopmentLogType = (type) => {
  developmentLogType.value = type
  window.activityDataLayer.push({
    eventName: "click_button",
    eventType: typeMap[type],
    eventReason: "开发者札记",
    aid: window.activity_name,
    gameId: window.game_id,
  });
}

// 生命周期
onMounted(() => {
  viewPageStartTime.value = new Date();
});

onUnmounted(() => {
  reportStayTime();
});
</script>

